<template>
  <div class="taskDelegation" v-loading="dialogLoading">
    <!-- 导航栏部分 -->
    <div class="el-menu-demo">
      <NavMenu />
    </div>
    <div class="taskDelegation-data">
      <div class="btns">
        <div>
          <el-input
            size="small"
            placeholder="请输入搜索工号"
            suffix-icon="el-icon-search"
            v-model.trim="queryParams.params.clientAccount"
            @change="getDimissionStaff()"
          ></el-input>
        </div>
      </div>
      <div class="taskDelegation-table">
        <el-table
          ref="multipleTable"
          :data="dimissionList"
          border
          height="100%"
          :default-sort="{ prop: 'date', order: 'descending' }"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" fixed></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="50"
            fixed
          ></el-table-column>
          <el-table-column
            v-for="item in tableColumns"
            :key="item.prop"
            v-bind="item"
            align="center"
          />
          <el-table-column label="操作" min-width="120" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="onGetRecords(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            background
            size="mini"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            @current-change="currentChange"
            @size-change="sizeChange"
            :current-page="Pagination.currentPage"
            :page-sizes="[15, 30, 40, 50, 100]"
            :page-size="Pagination.pagesize"
            align="center"
            class="pagination"
        ></el-pagination>
      </div>
    </div>
    <DrawerForm
      ref="DrawerForm"
      :dialogTitle="'设置离职转交'"
      :dialogWidth="'500px'"
      :formLabelWidth="formLabelWidth"
      :dialogFields="dialogFields"
      @submit="addEntrustment"
    />
    <DrawerTable
      ref="DrawerTable"
      :size="'80%'"
      :tableData="staffList"
      :tableColumns="staffTableColumns"
      :title="'离职转交记录（' + selectRow.psnName + '）'"
      :buttonList="buttonList"
      @getTaskName="getTaskName"
      @cancelEntrust="cancelEntrust"
      @handleSelectionChange="handleSelectionChange"
    />
  </div>
</template>

<script>
import DrawerTable from '../common/DrawerTable'
import DrawerForm from '../common/DrawerForm'
import bpmApi from '@/api/activityBPM/index'
import NavMenu from '../../common/NavMenu'
import { tableColumns, staffTableColumns, buttonList, dialogFields } from './config'
export default {
  name: 'dimissionTrans',
  components: {
    NavMenu,
    DrawerTable,
    DrawerForm,
  },
  data() {
    return {
      taskList: [],
      formLabelWidth: '100px',
      dimissionList: [],
      staffList: [],
      staffTableColumns,
      buttonList,
      loading: false,
      dialogLoading: false,
      totalCount: 0, //总条数
      Pagination: {
        currentPage: 1,
        pagesize: 15,
      },
      tableColumns, // 离职人员表格
      dialogFields, // 离职转交表格
      queryParams: {
        page: 1,
        size: 15,
        params: {},
      },
      batchCancelId: [],
      editType: 'insert',
      selectRow: {}, // 选中行
    }
  },
  mounted() {
    this.getDimissionStaff(this.Pagination)
  },
  methods: {
    getDimissionStaff(Pagination) {
      // 按条件查询该中心下所有的离职人员
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.queryParams))
      if (Pagination) {
        params.page = Pagination.currentPage
        params.size = Pagination.pagesize
      } else {
        this.Pagination.currentPage = params.page
      }
      bpmApi.dimission.pageQueryAll(params).then((res) => {
        if (res.code != '0000') {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
        this.dimissionList = res.data.content || []
        this.totalCount = res.data.totalElements
        this.loading = false
      })
    },
    onGetRecords(row) {
      // 通过离职人员的工号获取离职转交记录
      bpmApi.dimission
        .getResignationsByClientAccount({ clientAccount: row.psnCode })
        .then((res) => {
          if (res.code != '0000') {
            this.$message({
              type: 'error',
              message: res.msg,
            })
          }
          this.selectRow = row
          this.staffList = res.data || []
          this.$refs.DrawerTable.drawerVisible = true
        })
    },
    addEntrustment(form) {
      // 设置委托
      this.$refs.DrawerForm.dialogFormVisible = false
      let params = JSON.parse(JSON.stringify(form))
      params.procKeyAndDefNameList = []
      form.procKeyAndDefNameList.forEach((item) => {
        // 处理任务类型
        let value = item.split('-')
        params.procKeyAndDefNameList.push({
          procKey: value[0],
          procDefName: value[1],
        })
      })
      params.agentAccount = params.agent.split('-')[0]
      params.agent = params.agent.split('-')[1]
      params.client = this.selectRow.psnName
      params.clientAccount = this.selectRow.psnCode
      this.dialogLoading = true
      bpmApi.dimission[this.editType](params).then((res) => {
        this.dialogLoading = false
        this.$refs.DrawerForm.handleClose()
        if (res.code != '0000') {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        } else {
          this.$message.success('离职转交成功')
          this.onGetRecords(this.selectRow)
        }
      })
    },
    getTaskName(row) {
      this.$refs.DrawerForm.dialogFormVisible = true
      this.$nextTick(() => {
        // 处理设置委托数据
        this.editType = 'insert'
        this.$set(this.$refs.DrawerForm.form, 'checkboxValue', true)
        if (row) {
          this.$set(this.$refs.DrawerForm.form, 'checkboxValue', false)
          this.editType = 'revise'
        }
      })
      this.dialogLoading = true
      if (!this.taskList.length) {
        // 获取任务名称列表
        let params = JSON.parse(JSON.stringify(this.queryParams))
        bpmApi.procDef.listProcessDef(params).then((res) => {
          this.dialogLoading = false
          if (res.code != '0000') {
            this.$message({
              type: 'error',
              message: res.msg,
            })
            return
          }
          this.taskList = res.data || []
          this.dialogFields.forEach((item) => {
            if (item.prop === 'procKeyAndDefNameList') {
              item.fieldOption.options = this.taskList
            }
          })
        })
      } else {
        this.dialogLoading = false
      }
    },
    // 表格分页设置
    currentChange(currentPage) {
      this.Pagination.currentPage = currentPage
      this.getDimissionStaff(this.Pagination)
    },
    sizeChange(pagesize) {
      this.Pagination.pagesize = pagesize
      this.getDimissionStaff(this.Pagination)
    },
    cancelEntrust(row) {
      // 取消委托
      if (row) {
        this.batchCancelId = []
        this.batchCancelId.push(row.id)
      }
      if (!this.batchCancelId.length) {
        this.$message({
          type: 'warning',
          message: '请选择取消数据',
        })
        return
      }
      // 二次确认删除
      this.$confirm('确定要取消吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          bpmApi.dimission
            .cancellBatch({
              client: this.selectRow.psnName,
              clientAccount: this.selectRow.psnCode,
              resignationIdList: this.batchCancelId,
            })
            .then((res) => {
              if (res.code != '0000') {
                this.$message({
                  type: 'error',
                  message: res.msg,
                })
              } else {
                this.$message.success('取消成功')
              }
              this.onGetRecords(this.selectRow)
            })
        })
        .catch(() => {})
    },
    handleSelectionChange(val) {
      // 批量取消委托
      this.batchCancelId = []
      val.forEach((item) => {
        this.batchCancelId.push(item.id)
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.taskDelegation {
  .taskDelegation-data {
    margin: 10px 20px;
    .btns {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
    .taskDelegation-table {
      display: flex;
      flex-direction: column;
      height: calc(100vh - 150px);
      .pagination{
        margin-top: 20px;
      }
    }
  }
}

/deep/ .el-form-item__label {
  font-size: 16px;
}
// 表格样式
/deep/ tbody {
  cursor: pointer;
}
// 表格样式
/deep/ .el-table {
  thead th {
    color: #525252;
    background-color: #f2f6fc;
  }
  .el-table__cell {
    padding: 3px 0;
  }
}
/deep/ .el-autocomplete {
  width: 100%;
}
</style>
